import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { ApiProgress } from "../../Utilities/ApiProgress";
import { useProductSettingsContext } from "./context/ProductSettingsContext";
import { ProductSettingsDistributorGrid } from "./components/ProductSettingsDistributorGrid";
import InfoDialog from './dialogs/InfoDialog';
import ErrorDialog from './dialogs/ErrorDialog';
import FileUpload from "../../Components/FileUpload";
import { PausedIndicator } from "../../Components/PausedIndicator";
import { handleProductSettingsExport } from "./utils/ProductSettingsExport";

const enablePauseIndicator = process.env.REACT_APP_ENABLE_PAUSE_INDICATOR === 'true';
const enableSeasonalForecast = process.env.REACT_APP_ENABLE_SEASONAL_FORECAST === 'true';
const enableInMarketDate = process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true';

const getProductSettingsUploadTemplateCsv = () =>
    process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true'
        ? 'distributor,sku,offeringStatus,fulfillmentMethod,directDistributor,palletQuantity,palletDivisor,unitWeight,inMarketDate\n'
        : 'distributor,sku,offeringStatus,fulfillmentMethod,directDistributor,palletQuantity,palletDivisor,unitWeight\n';

const ProductSettings = () => {
    const {
        dataLoaded,
        productDefaults,
        unfilteredProductSettingsDistributorTable,
        inMarketDateError,
        clearInMarketDateError,
    } = useProductSettingsContext();

    const anyPaused = enablePauseIndicator && (unfilteredProductSettingsDistributorTable?.some(row => row?.paused) ?? false);

    const onExportClick = () => handleProductSettingsExport({
        distributorRows: unfilteredProductSettingsDistributorTable,
        productDefaults,
        includeSeasonal: enableSeasonalForecast,
        includeInMarketDate: enableInMarketDate,
    });

    return (dataLoaded ? <Paper elevation={1} sx={{ padding: 2, margin: 2 }}>
        <Stack direction='column' spacing={1}>
            <Grid container>
                <Grid item xs={8}>
                    <Stack direction='row' alignItems='center' spacing={1}>
                        {anyPaused ? <PausedIndicator size={28} /> : null}
                        <Typography
                            variant='h4'>{productDefaults.brandFamily} {productDefaults.description} ({productDefaults.sku})</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, flexWrap: 'nowrap' }}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onExportClick}
                        sx={{ whiteSpace: 'nowrap', flexShrink: 0, mt: '-4px' }}
                    >
                        Export Settings
                    </Button>
                    <FileUpload
                        uploadUrl="api/products/productSettings"
                        buttonText="Upload Settings"
                        accept=".csv"
                        InfoDialogComponent={InfoDialog}
                        ErrorDialogComponent={ErrorDialog}
                        templateDownloadFileName="ProductSettingsUploadTemplate.csv"
                        templateDownloadTooltip="Download template"
                        getTemplateDownloadContent={getProductSettingsUploadTemplateCsv}
                    />
                </Grid>
            </Grid>
            <div style={{ width: "100%", height: "70vh" }}>
                <ProductSettingsDistributorGrid />
            </div>
        </Stack>
        <Dialog open={!!inMarketDateError} onClose={clearInMarketDateError}>
            <DialogTitle>Invalid In-Market Date</DialogTitle>
            <DialogContent>
                <Typography>{inMarketDateError}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={clearInMarketDateError} autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
    </Paper> : <ApiProgress />)
}

export default ProductSettings;